function createShipmentsAccessButtonHandler(authAccess, locations, companyStatus) {
  return authAccess && locations.length > 0 && companyStatus === 'active';
}

export { createShipmentsAccessButtonHandler };
